module.exports = __webpack_public_path__ + "img/programme5.db56e1b6.png";